import React from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import moment from 'moment'
import Header from '../containers/HeaderContainer'

const ExternalLinkIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" className="h-3.5 w-3.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M14 5h5v5" />
        <path strokeLinecap="round" strokeLinejoin="round" d="m19 5-8 8" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 14.5v2.75A1.75 1.75 0 0 1 17.25 19h-10.5A1.75 1.75 0 0 1 5 17.25V6.75A1.75 1.75 0 0 1 6.75 5H9.5" />
    </svg>
)

const BackIcon = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="h-3.5 w-3.5">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 6 9 12l6 6" />
    </svg>
)

class Events extends React.Component {
    state = {
        busy: false,
        checkingUser: true,
        clientId: '',
        notice: ''
    }

    componentDidMount() {
        const clientId = this._isOverview() ? '' : (this.props.match && this.props.match.params ? this.props.match.params[0] || this._clientIdFromPath() : this._clientIdFromPath())
        if (!this.props.user) {
            this.setState({ checkingUser: true, clientId }, () => {
                this.props.checkUserSession(() => {
                    this.setState({ checkingUser: false })
                    this._fetchEvents()
                })
            })
        } else {
            this.setState({ checkingUser: false, clientId }, () => {
                this._fetchEvents()
            })
        }
    }

    _isOverview() {
        return this.props.location && this.props.location.pathname === '/events'
    }

    _clientIdFromPath() {
        const pathArr = this.props.location.pathname.split('/')
        return pathArr[pathArr.length - 1]
    }

    _fetchEvents(clientId = this.state.clientId) {
        this.setState({ busy: true }, () => {
            if (this._isOverview()) {
                this.props.fetchEventsOverview(() => {
                    this.setState({ busy: false })
                })
            } else {
                this.props.fetchEvents(clientId, () => {
                    this.setState({ busy: false })
                })
            }
        })
    }

    _createEvent() {
        if (!window.confirm('Create a new event for this client?')) return
        this.setState({ busy: true, notice: '' }, () => {
            this.props.createNextEvent({ clientId: this.state.clientId }, (response) => {
                if (response && response.error) {
                    this.setState({ busy: false, notice: response.message || 'Unable to create event.' })
                    return
                }
                this.setState({ busy: false, notice: 'New event created.' }, () => this._fetchEvents(this.state.clientId))
            })
        })
    }

    _stat(label, value) {
        return (
            <div>
                <div className="text-[11px] font-semibold uppercase tracking-[0.24em] text-slate-400 dark:text-slate-500">{label}</div>
                <div className="mt-1 text-sm font-semibold text-slate-700 dark:text-slate-200">{value}</div>
            </div>
        )
    }

    _eventCompletedAt(event) {
        return event.endDate || event.drawnAt || event.drawDate || ''
    }

    _eventMoment(event) {
        const value = event.completed ? this._eventCompletedAt(event) : event.drawDate
        const parsed = value ? moment(value) : null
        return parsed && parsed.isValid() ? parsed : null
    }

    _eventClient(event) {
        return event.client || {}
    }

    _eventClientId(event) {
        const client = this._eventClient(event)
        return event.clientId || event.PK || client.PK || this.state.clientId
    }

    _renderEventRow(event, index, options = {}) {
        const client = this._eventClient(event)
        const clientId = this._eventClientId(event)
        const clientName = client.name || event.clientName || clientId
        const title = event.completed ? event.SK : (client.charity || clientName)
        const publicUrl = !event.completed && client.stub ? 'https://s50.events/' + client.stub : ''

        return (
            <div key={(clientId || 'client') + '-' + event.SK} className={'px-6 py-3 transition hover:bg-slate-100/90 dark:hover:bg-slate-900/70 ' + (index % 2 === 1 ? 'bg-slate-50/95 dark:bg-slate-900/55' : 'bg-white/95 dark:bg-slate-950/70')}>
                <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
                    <div className="min-w-0 flex-1">
                        <div className="flex flex-wrap items-center gap-3">
                            <div className="text-lg font-semibold text-slate-900 dark:text-white">{title}</div>
                            {!event.completed ?
                                <span className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
                                    {event.SK}
                                </span>
                                : null}
                            {options.showClient && event.completed ?
                                <a href={'/clients/' + clientId} className="inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-slate-600 no-underline hover:text-sky-600 dark:bg-slate-800 dark:text-slate-300 dark:hover:text-sky-300">
                                    {clientName}
                                </a>
                                : null}
                            {options.showClient && !event.completed ?
                                <a href={'/clients/' + clientId} className="text-xs font-semibold text-slate-500 no-underline hover:text-sky-600 dark:text-slate-400 dark:hover:text-sky-300">
                                    {clientName}
                                </a>
                                : null}
                            <span className={'inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] ' + (event.completed
                                ? 'bg-amber-100 text-amber-800 dark:bg-amber-500/10 dark:text-amber-300'
                                : 'bg-emerald-100 text-emerald-800 dark:bg-emerald-500/10 dark:text-emerald-300')}>
                                {event.completed ? 'Completed' : 'Live'}
                            </span>
                        </div>
                        <div className="mt-3 grid grid-cols-2 gap-4 sm:grid-cols-4">
                            {this._stat('Prize pool', '$' + Number(event.prizePool || 0).toFixed(2))}
                            {this._stat('Tickets sold', event.ticketCount || 0)}
                            {this._stat('Max prize', '$' + Number(event.maxPrizePool || 0).toFixed(2))}
                            {this._stat(event.completed ? 'Drawn' : 'Draw date', this._eventMoment(event) ? this._eventMoment(event).format('DD MMM YYYY h:mma') : 'Not set')}
                        </div>
                    </div>
                    <div className="flex flex-wrap gap-2 xl:justify-end">
                        <a
                            href={'/events/' + clientId + '/' + event.SK + '/edit'}
                            className="inline-flex items-center justify-center rounded-2xl bg-slate-900 px-3 py-2 text-xs font-semibold text-white no-underline transition hover:bg-slate-800 dark:bg-sky-500 dark:text-slate-950 dark:hover:bg-sky-400"
                        >
                            Manage
                        </a>
                        {publicUrl ?
                            <a
                                href={publicUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center justify-center gap-1.5 rounded-2xl border border-sky-300 px-3 py-2 text-xs font-semibold text-sky-700 no-underline transition hover:border-sky-400 hover:bg-sky-50 dark:border-sky-500/40 dark:text-sky-200 dark:hover:bg-sky-500/10"
                            >
                                {ExternalLinkIcon}
                                Launch
                            </a>
                            : null}
                        <a
                            href={'/events/' + clientId + '/' + event.SK}
                            className="inline-flex items-center justify-center rounded-2xl border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 no-underline transition hover:border-slate-400 hover:bg-slate-50 dark:border-slate-700 dark:text-slate-200 dark:hover:bg-slate-900"
                        >
                            Report
                        </a>
                    </div>
                </div>
            </div>
        )
    }

    render() {
        if (this.state.checkingUser || this.state.busy) {
            return <div className="px-4 py-5 text-center">Loading events...</div>
        }

        if (!this.props.user) {
            return <Redirect to='/' />
        }

        const client = this.props.client
        const isOverview = this._isOverview()
        const allEvents = (isOverview ? (this.props.eventsOverview || []) : (this.props.events || [])).slice()
        const sevenDaysAgo = moment().subtract(7, 'days')
        const liveEvents = allEvents
            .filter((evt) => !evt.completed)
            .sort((a, b) => {
                const aDate = this._eventMoment(a)
                const bDate = this._eventMoment(b)
                if (aDate && bDate) return aDate.valueOf() - bDate.valueOf()
                if (aDate) return -1
                if (bDate) return 1
                return String(b.SK).localeCompare(String(a.SK))
            })
        const recentDrawnEvents = allEvents
            .filter((evt) => {
                if (!evt.completed) return false
                const drawnAt = this._eventMoment(evt)
                return drawnAt && drawnAt.isSameOrAfter(sevenDaysAgo)
            })
            .sort((a, b) => this._eventMoment(b).valueOf() - this._eventMoment(a).valueOf())
        const events = isOverview ? liveEvents.concat(recentDrawnEvents) : allEvents.sort((a, b) => String(b.SK).localeCompare(String(a.SK)))
        const hasLiveEvent = events.some((evt) => !evt.completed)

        return (
            <div className="min-h-screen lg:flex">
                <Header />
                <main className="min-w-0 flex-1 px-4 py-4 sm:px-6 lg:px-10 lg:py-8">
                    <div className="mx-auto max-w-7xl">
                        <div className="rounded-[28px] border border-slate-200/70 bg-white/80 p-6 shadow-soft backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
                            <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
                                <div>
                                    {!isOverview ?
                                        <a href={client ? '/clients/' + client.PK : '/clients'} className="inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.28em] text-sky-600 no-underline dark:text-sky-300">
                                            {BackIcon} Back to client
                                        </a>
                                        : <div className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-600 dark:text-sky-300">Events</div>}
                                    <h1 className="mt-3 text-3xl font-extrabold tracking-tight text-slate-900 dark:text-white sm:text-4xl">{isOverview ? 'Event overview' : (client ? client.name : 'Events')}</h1>
                                    <p className="mt-3 max-w-3xl text-sm leading-6 text-slate-600 dark:text-slate-300 sm:text-base">
                                        {isOverview ? 'Live raffles are listed first, followed by events drawn in the last 7 days.' : 'Use a stacked list so live and historic raffles are easier to scan, while keeping the key numbers and status visible in each row.'}
                                    </p>
                                </div>
                                {!isOverview && !hasLiveEvent ?
                                    <button
                                        className="inline-flex items-center justify-center rounded-2xl bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 dark:bg-sky-500 dark:text-slate-950 dark:hover:bg-sky-400"
                                        onClick={() => this._createEvent()}
                                    >
                                        Create next event
                                    </button>
                                    : null}
                            </div>
                            {this.state.notice ? <div className="mt-4 rounded-2xl border border-sky-200 bg-sky-50 px-4 py-3 text-sm text-sky-800 dark:border-sky-500/20 dark:bg-sky-500/10 dark:text-sky-200">{this.state.notice}</div> : null}
                        </div>

                        <div className="mt-6 overflow-hidden rounded-[28px] border border-slate-200/70 bg-white/80 shadow-soft backdrop-blur dark:border-slate-800 dark:bg-slate-950/70">
                            <div className="divide-y divide-slate-200/70 dark:divide-slate-800">
                                {isOverview && liveEvents.length > 0 ?
                                    <div className="bg-slate-50/80 px-6 py-3 text-xs font-semibold uppercase tracking-[0.24em] text-slate-500 dark:bg-slate-900/60 dark:text-slate-400">Live events</div>
                                    : null}

                                {isOverview ? liveEvents.map((event, index) => this._renderEventRow(event, index, { showClient: true })) : events.map((event, index) => this._renderEventRow(event, index))}

                                {isOverview && recentDrawnEvents.length > 0 ?
                                    <div className="bg-slate-50/80 px-6 py-3 text-xs font-semibold uppercase tracking-[0.24em] text-slate-500 dark:bg-slate-900/60 dark:text-slate-400">Drawn in the last 7 days</div>
                                    : null}

                                {isOverview ? recentDrawnEvents.map((event, index) => this._renderEventRow(event, liveEvents.length + index, { showClient: true })) : null}

                                {events.length === 0 ?
                                    <div className="px-6 py-14 text-center text-sm text-slate-500 dark:text-slate-400">
                                        {isOverview ? 'No live events or events drawn in the last 7 days were returned.' : 'No events were returned for this client.'}
                                    </div>
                                    : null}
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        )
    }
}

export default withRouter(Events)
